
/* injects from baggage-loader */

export const initFeedbackTexts = [
    'Venha comigo! <br> Iremos <b>salvar</b> todos os <b>filhotes</b> da rede dos pescadores.<br> <b>Clique e arraste</b> com o mouse para colocar os filhotes em um <b>lugar seguro</b>, próximo às suas mães. <br> Boa sorte!',
];

export const AnimalTypes = {
    boto: 1,
    peixeboi: 2,
    tucunare: 3
}

export const FishIcons = {
    boto: {
        default: require('_images/stages/stage-one/boto.png')
    },
    peixeboi: {
        default: require('_images/stages/stage-one/peixeboi.png')
    },
    tucunare: {
        default: require('_images/stages/stage-one/tucunare.png')
    }
}

export const feedbackTexts = [
    'Muito bem!<br> Agora que todos os <b>filhotes</b> estão a <b>salvo</b>  da rede de pescadores, ajude-me a <b>contar quantos animais</b> de cada espécie <b>nós salvamos</b>.<br> Vamos lá.'
];




export const thirdChallengeText = [
    'Os animais <b>encontraram</b> o resto de suas <b>famílias</b> e <b>foram embora</b> mais rápido do que eu esperava! Parece que vamos <b>continuar</b> a missão <b>sem eles</b>.',
    'Por sorte, consegui anotar a <b>quantidade</b> de <b>cada conjunto</b> de animais que passou por aqui. Você pode usar <b>estes dados</b> para <b>resolver</b> o próximo <b>desafio</b>'
];

const helpImg = require('_images/stage-helps/peixeboi.png');

export const helpTpl = `
    <div class='container-fluid'>
        <div class='row'>        
            <div class='col-xs-7'>
                <img src='${helpImg}' class='img-responsive' />
            </div>
            <div class='col-xs-5 text-left'>
                <div class='container-fluid'>
                    <p class='subtitle'>Para salvar os filhotes, <b>clique e arraste</b> o animalzinho e leve-o para <b>junto da sua mãe</b>.</p>
                    <p class='subtitle'>Em seguida, você deve <b>preencher</b> as quantidades de cada animal no <b>quadradinho</b> correspondente para, em seguida, <b>responder as perguntas</b> que serão feitas.</p>
                    <p class='subtitle'>Vamos lá!</p>
                </div>
            </div>
        </div>
    </div>
`


// WEBPACK FOOTER //
// ./src/app/pages/stage-one/stage-one.const.js